import React from 'react';
import { FaTrophy, FaHistory, FaEye, FaBullseye } from 'react-icons/fa';
import Footer from '../components/Footer';
import PageCover from '../components/PageCover';
import { useLanguage } from '../context/LanguageContext';

const AboutPage = () => {
  const { language } = useLanguage();

  const text = {
    ar: {
      title: 'عن الرابطة',
      subtitle: 'بطولة الرابطة الوطنية للهواة المستوى الثاني',
      definitionTitle: 'تعريف الرابطة',
      definitionContent: `تم إحداث الرابطة الوطنية للهواة مستوى ثانٍ في شهر جويلية 2017 بقرار من المكتب الجامعي، لتندرج ضمن هرم كرة القدم التونسية كقسم رابع، وتكون محطة بين الهواية ونصف الاحتراف: فرق الرابطات الجهوية والرابطة الوطنية للهواة (نظام نصف هواية). وقد ضمت في بدايتها عدد 48 فريقًا.

عيّنت الجامعة التونسية لكرة القدم هيئة تأسيسية برئاسة السيد ناجي الشاهد لإدارة شؤونها من جويلية 2017 إلى غاية 03 فيفري 2018، تاريخ أول جلسة عامة انتخابية لإتمام ما تبقى من المدة النيابية 2016-2020.`,
      foundingCommittee: 'الهيئة التأسيسية (جويلية 2017 - فيفري 2018):',
      electedCommittee1: 'الهيئة المنتخبة في 03 فيفري 2018 (إتمام الفترة 2018-2020):',
      electedCommittee2: 'الهيئة المنتخبة في جوان 2020 (الفترة 2020-2024):',
      steeringCommittee: 'المرحلة الانتقالية (2024-2025):',
      steeringContent: 'إثر نهاية هذه المرحلة، عيّنت هيئة التسوية بالجامعة التونسية لكرة القدم هيئة تسييرية للرابطة الوطنية للهواة مستوى ثانٍ برئاسة السيد الطيب العويتي، وذلك مطلع الموسم الرياضي 2024-2025. وتواصلت أعمال هذه اللجنة إلى موفى شهر جانفي 2026.',
      currentCommittee: 'الهيئة المنتخبة للفترة النيابية 2025-2029:',
      vision: 'الرؤية',
      visionContent: 'أن نكون الرابطة الرائدة في تطوير كرة القدم للهواة في تونس، من خلال توفير بيئة تنافسية عادلة ومنظمة تساهم في اكتشاف المواهب وتطوير اللاعبين.',
      mission: 'المهمة',
      missionContent: 'تنظيم وإدارة بطولة المستوى الثاني بشكل احترافي، وضمان تطبيق القوانين واللوائح، وتوفير الدعم اللازم للأندية المشاركة، والعمل على تطوير البنية التحتية الرياضية.',
      values: 'القيم',
      valuesContent: 'النزاهة، الشفافية، العدالة، الاحترافية، التطوير المستمر، روح الفريق'
    },
    fr: {
      title: 'À Propos de la Ligue',
      subtitle: 'Ligue Nationale de Football Amateur - Niveau 2',
      definitionTitle: 'Définition de la Ligue',
      definitionContent: `La Ligue Nationale de Football Amateur Niveau 2 a été créée en juillet 2017 par décision du Bureau Fédéral, pour s'insérer dans la pyramide du football tunisien en tant que quatrième division. Elle constitue une transition entre l'amateurisme et le semi-professionnalisme. Elle comptait 48 équipes à ses débuts.

La Fédération Tunisienne de Football a nommé un comité de fondation présidé par M. Naji Chahed pour gérer ses affaires de juillet 2017 jusqu'au 3 février 2018, date de la première assemblée générale élective pour compléter le mandat 2016-2020.`,
      foundingCommittee: 'Comité de Fondation (Juillet 2017 - Février 2018) :',
      electedCommittee1: 'Comité Élu le 03 Février 2018 (Mandat 2018-2020) :',
      electedCommittee2: 'Comité Élu en Juin 2020 (Mandat 2020-2024) :',
      steeringCommittee: 'Phase de Transition (2024-2025) :',
      steeringContent: "Suite à cette phase, le comité de normalisation de la FTF a nommé un comité de gestion présidé par M. Taieb El-Oueiti au début de la saison 2024-2025. Ce comité a officié jusqu'à fin janvier 2026.",
      currentCommittee: 'Comité Élu pour le Mandat 2025-2029 :',
      vision: 'Vision',
      visionContent: 'Être la ligue leader dans le développement du football amateur en Tunisie, en fournissant un environnement compétitif équitable et organisé.',
      mission: 'Mission',
      missionContent: 'Organiser et gérer le championnat de Niveau 2 de manière professionnelle, garantir l\'application des règlements, et soutenir les clubs.',
      values: 'Valeurs',
      valuesContent: 'Intégrité, Transparence, Équité, Professionnalisme, Développement continu, Esprit d\'équipe'
    }
  };

  const t = text[language];

  const committees = [
    {
      title: t.foundingCommittee,
      president: 'ناجي الشاهد',
      vice: 'محمد العوادي',
      image: '/images/about_history.png',
      members: ['معز الهاشمي', 'عمر الراشدي', 'محمد فوزي بوزيد', 'نور الدين بوقطفة', 'خالد العبيدي', 'محمد ياسين الشيخ', 'وليد الطريفي', 'أنيس بن أحمد', 'محمد عزيز زواوي']
    },
    {
      title: t.electedCommittee1,
      president: 'ناجي الشاهد',
      vice: 'محمد العوادي',
      image: '/images/about_history_2018.jpg',
      members: ['عمر الراشدي', 'محمد فوزي بوزيد', 'معز الهاشمي', 'محمد ياسين الشيخ', 'هيثم غلابي', 'خالد العبيدي', 'أنيس بن أحمد', 'وليد الطريفي', 'محمد عزيز زواوي']
    },
    {
      title: t.electedCommittee2,
      president: 'ناجي الشاهد',
      vice1: 'محسن عبد القادر',
      vice2: 'آية الله الهيشري',
      image: '/images/about_history_2020.png',
      members: ['محمد العوادي', 'معز الهاشمي', 'عمر الراشدي', 'محمد فوزي بوزيد', 'خالد العبيدي', 'محمد ياسين الشيخ', 'وليد الطريفي', 'نور الدين بوقطفة', 'سليم عبد الحفيظ']
    }
  ];

  const currentBoard = [
    { name: 'محمد علي خليفة', role: 'رئيس وناطق رسمي' },
    { name: 'وليد الطريفي', role: 'نائب أول لرئيس الرابطة' },
    { name: 'منير الساري', role: 'نائب ثانٍ لرئيس الرابطة' },
    { name: 'محمد علي كربية', role: 'أمين مال' },
    { name: 'علاء معتوق', role: 'أمين مال مساعد' },
    { name: 'وسام البحروني', role: 'رئيس لجنة القوانين' },
    { name: 'آية الله الهيشري', role: 'رئيس لجنة التأديب والروح الرياضية' },
    { name: 'محمد القلال', role: 'رئيس لجنة التنظيم ونائب رئيس لجنة التأديب والروح الرياضية' },
    { name: 'مهدي بن دوة', role: 'رئيس لجنة المسابقات' },
    { name: 'عبد الرزاق الماجدي', role: 'رئيس لجنة المتابعة ونائب رئيس لجنة القوانين' },
    { name: 'محمد الطيب الكسّابي', role: 'رئيس اللجنة الفنية ونائب لجنة المسابقات' },
    { name: 'محمد الأطرش', role: 'رئيس لجنة الإعلام والاستشهار وناطق رسمي ثانٍ' }
  ];

  return (
    <div style={styles.container}>
      <PageCover title={t.title} subtitle={t.subtitle} icon={FaTrophy} />

      {/* Main Definition Section */}
      <section style={styles.content}>
        <div style={styles.definitionCard}>
          <h2 style={styles.mainTitle}>{t.definitionTitle}</h2>
          <div style={styles.definitionText}>
            {t.definitionContent.split('\n\n').map((p, i) => (
              <p key={i} style={{ marginBottom: '15px' }}>{p}</p>
            ))}
          </div>
          <div style={styles.imageContainer}>
            <img
              src="/images/about_history.png"
              alt="Bureau de la Ligue 2016-2020"
              style={styles.historyImage}
            />
          </div>
        </div>

        {/* Committees History */}
        <div style={styles.historyGrid}>
          {committees.map((c, i) => (
            <div key={i} style={styles.historyCard}>
              <h3 style={styles.historyCardTitle}>{c.title}</h3>

              {/* Add image for 2020 committee */}
              {c.image && (
                <div style={styles.cardImageContainer}>
                  <img src={c.image} alt={c.title} style={styles.cardImage} />
                </div>
              )}

              <ul style={styles.memberList}>
                <li style={styles.presidentItem}><strong>{c.president}</strong> : رئيس</li>
                {c.vice && <li style={styles.viceItem}><strong>{c.vice}</strong> : نائب رئيس</li>}
                {c.vice1 && <li style={styles.viceItem}><strong>{c.vice1}</strong> : نائب أول</li>}
                {c.vice2 && <li style={styles.viceItem}><strong>{c.vice2}</strong> : نائب ثانٍ</li>}
                <div style={styles.membersSeparator}>{language === 'ar' ? 'الأعضاء:' : 'Membres :'}</div>
                <div style={styles.membersGrid}>
                  {c.members.map((m, j) => (
                    <li key={j} style={styles.memberItem}>{m}</li>
                  ))}
                </div>
              </ul>
            </div>
          ))}
        </div>

        {/* Transition / Steering */}
        <div style={styles.highlightCard}>
          <h3 style={styles.historyCardTitle}>{t.steeringCommittee}</h3>
          <p style={styles.cardText}>{t.steeringContent}</p>
        </div>

        {/* Current Office */}
        <div style={styles.currentOfficeCard}>
          <h2 style={styles.currentOfficeTitle}>{t.currentCommittee}</h2>

          <div style={styles.currentBoardImageContainer}>
            <img
              src="/images/about_current_board.png"
              alt="Bureau de la Ligue 2025-2029"
              style={styles.currentBoardImage}
            />
          </div>

          <div style={styles.officeGrid}>
            {currentBoard.map((m, i) => (
              <div key={i} style={styles.officeMember}>
                <div style={styles.officeRole}>{m.role}</div>
                <div style={styles.officeName}>{m.name}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Top Feature Cards (Vision, mission, etc) */}
        <div style={styles.smallGrid}>
          <div style={styles.card}>
            <FaEye style={styles.cardIconSmall} />
            <h2 style={styles.cardTitle}>{t.vision}</h2>
            <p style={styles.cardText}>{t.visionContent}</p>
          </div>
          <div style={styles.card}>
            <FaBullseye style={styles.cardIconSmall} />
            <h2 style={styles.cardTitle}>{t.mission}</h2>
            <p style={styles.cardText}>{t.missionContent}</p>
          </div>
          <div style={styles.card}>
            <FaTrophy style={styles.cardIconSmall} />
            <h2 style={styles.cardTitle}>{t.values}</h2>
            <p style={styles.cardText}>{t.valuesContent}</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8f9fa'
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '40px 20px'
  },
  definitionCard: {
    background: 'white',
    borderRadius: '20px',
    padding: '40px',
    marginBottom: '40px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
    borderTop: '5px solid #c41e3a'
  },
  mainTitle: {
    fontSize: '32px',
    fontWeight: 'bold',
    color: '#1a365d',
    marginBottom: '20px',
    borderBottom: '2px solid #eee',
    paddingBottom: '15px'
  },
  definitionText: {
    fontSize: '18px',
    lineHeight: '1.8',
    color: '#444',
    textAlign: 'justify'
  },
  imageContainer: {
    marginTop: '30px',
    textAlign: 'center',
    borderRadius: '15px',
    overflow: 'hidden',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
  },
  historyImage: {
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
    margin: '0 auto'
  },
  historyGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '25px',
    marginBottom: '40px'
  },
  historyCard: {
    background: 'white',
    borderRadius: '15px',
    padding: '30px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
    borderLeft: '4px solid #1a365d'
  },
  historyCardTitle: {
    fontSize: '19px',
    fontWeight: 'bold',
    color: '#c41e3a',
    marginBottom: '20px',
    minHeight: '50px'
  },
  cardImageContainer: {
    marginBottom: '15px',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
  },
  cardImage: {
    width: '100%',
    height: 'auto',
    display: 'block'
  },
  memberList: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  presidentItem: {
    fontSize: '17px',
    padding: '10px 0',
    borderBottom: '1px solid #f0f0f0',
    color: '#1a365d'
  },
  viceItem: {
    fontSize: '16px',
    padding: '8px 0',
    color: '#555'
  },
  membersSeparator: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#888',
    margin: '20px 0 10px',
    textTransform: 'uppercase'
  },
  membersGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px'
  },
  memberItem: {
    fontSize: '14px',
    color: '#666',
    background: '#f9f9f9',
    padding: '5px 10px',
    borderRadius: '5px'
  },
  highlightCard: {
    background: 'linear-gradient(135deg, #1a365d, #0d1b2e)',
    color: 'white',
    borderRadius: '15px',
    padding: '30px',
    marginBottom: '40px',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
  },
  currentOfficeCard: {
    background: 'white',
    borderRadius: '20px',
    padding: '40px',
    marginBottom: '40px',
    boxShadow: '0 15px 40px rgba(0,0,0,0.08)',
    border: '1px solid #eee'
  },
  currentOfficeTitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#1a365d',
    marginBottom: '40px'
  },
  currentBoardImageContainer: {
    marginBottom: '40px',
    borderRadius: '15px',
    overflow: 'hidden',
    boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
    maxWidth: '900px',
    margin: '0 auto 40px'
  },
  currentBoardImage: {
    width: '100%',
    height: 'auto',
    display: 'block'
  },
  officeGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '20px'
  },
  officeMember: {
    background: '#f8f9fa',
    padding: '20px',
    borderRadius: '12px',
    textAlign: 'center',
    transition: 'transform 0.3s',
    border: '1px solid #e9ecef'
  },
  officeRole: {
    fontSize: '13px',
    color: '#c41e3a',
    fontWeight: '700',
    marginBottom: '8px',
    textTransform: 'uppercase'
  },
  officeName: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#1a365d'
  },
  smallGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '25px',
    marginTop: '60px'
  },
  card: {
    background: 'white',
    borderRadius: '15px',
    padding: '30px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
    textAlign: 'center'
  },
  cardIconSmall: {
    fontSize: '32px',
    color: '#c41e3a',
    marginBottom: '15px'
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1a365d',
    marginBottom: '10px'
  },
  cardText: {
    fontSize: '15px',
    color: '#666',
    lineHeight: '1.6'
  }
};

export default AboutPage;
